module.exports = ".error-msg p {font-size: 14px; color: red; margin-top: 20px; text-align: center; }"